<template>
  <div class="m-3">
    <Tables ref="tableGridsDetalhesPrestacaoContasDiversos"
            :columns= this.coluna
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            :newHeaderStatus="false"
            :showCheckInput="true"
            @check="eventcheck"
            v-on:Load="GetDespesasByFuncioarioId">
            <tr v-for="obj in dataDespesas" :key="obj.id">
               <td class="text-center" style="font-size: 20px; vertical-align: middle;"><input type="checkbox" :id="obj.id" class="check-table"></td>
               <TableColumn  v-if="usuarioGrupoDV.isCoordenador || usuarioGrupoDV.isTecnico" :IsTextGreeen="obj.preAprovada == 'Sim'" v-on:Edit="$emit('onSelect',data)" :status="1" :value="obj.preAprovada" />
               <TableColumn :IsText="true"   :status="1" :value="obj.dataRegistroDespesaFormatada" />
               <TableColumn :IsTextYellow="obj.statusDespesa != 2 && obj.statusDespesa != 3 && obj.statusDespesa != 9"  :IsTextOrange="obj.statusDespesa == 9" :IsTextGreen="obj.statusDespesa == 2" :IsTextBlue="obj.statusDespesa == 3 ? true : false" :status="1" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL) || etapasMistas" :value="obj.statusDespesa != null ?  obj.statusDespesa == 2 ? 'AG. APROVAÇÃO CONTROLADORIA' : obj.statusDespesa == 3 ? 'AG. APROVAÇÃO DIRETORIA' : obj.statusDespesa == 9 ? 'AG. APROVAÇÃO TÉCNICO' : 'AG. APROVAÇÃO COORDENADOR' :  'N/D'" />
               <TableColumn :IsText="true"   :status="1" :value="obj.subCategoriaDescricao" />
               <TableColumn :IsText="true"   :status="1" :value="obj.quantidade" />
               <TableColumn :IsText="true"   :status="1" :value="obj.totalFuncionarioVinculados" />
               <TableColumn :IsText="true"   :status="1" :value="formatMoney(obj.valor)" />
               <TableColumn
                :newEditGama="true"
                :HasChange="true"
                :IsViewExpenses="true"
                v-on:Edit="onSelect(obj)"
                v-on:DetailsExpense="openPopup(obj)"></TableColumn>
            </tr>
   </Tables>
   <b-modal ref="openModalDetail"
          size="lg"
          id="open-modal"
          :clickToClose="false"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          :hide-footer="true"
          centered
          body-class="p-0"
          hide-header-close
          >
          <template #modal-title="{ close }">
            <div class="header w-100">
              <div class="titulo-modal">COMPROVANTE ( {{ posicaoSelecionada + 1 }} / {{ dataDespesas.length }} )</div>
              <div class="button-modal d-flex">
                <div class="btn-header">
                  <div class="btn-repappr">
                    <div class="btn-appr-rep" v-if="hasRole(roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
                      <button class="btn-rep-popup" @click="modalDevolucaoUnicaDespesa"><i class="fas fa-thumbs-down"></i> Reprovar</button>
                      <button v-if="usuarioGrupoDV.isTecnico" @click="PreAprove" class="btn-appr-popup"><i class="fas fa-thumbs-up mr-2"></i>Pré-aprovar</button>
                      <button v-if="hasRole(roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL) && temCoordenador == false || temCoordenador == null" @click="aprovaUnicaDespesa(despesasSelecionada.id)" class="btn-appr-popup"><i class="fas fa-thumbs-up mr-2"></i>Aprovar</button>
                      <button v-if="!usuarioGrupoDV && hasRole(roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL) && temCoordenador != null" @click="Aprove" class="btn-appr-popup"><i class="fas fa-thumbs-up mr-2"></i>Aprovar</button>
                      <button v-if="hasRole(roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL)" class="btn-appr-popup" @click="Aprove"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                    </div>
                    <div class="btn-appr-rep" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) && despesasSelecionada.statusDespesa == 2|| hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL) && despesasSelecionada.statusDespesa == 2">
                      <button class="btn-rep-popup" @click="modalDevolucaoUnicaDespesa" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
                      <button class="btn-appr-popup" @click="Aprove"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                    </div>
                  </div>
                </div>
                <div class="ml-3 closepoup" @click="close()"><i class="fa fa-times"></i></div>
              </div>
          </div>
          </template>
          <div class="ml-2 mr-2">
              <div class="descricao-despesa">
                <div class="d-flex descricao">
                  <div class="d-flex expensesSelected">
                    <div class="col-md-3">
                      <label>Data do Gasto</label>
                      <div class="result-panel">{{ despesasSelecionada.dataRegistroDespesaFormatada }}</div>
                    </div>
                    <div class="col-md-3">
                      <label>Valor</label>
                      <div class="result-panel">{{ formatMoney(despesasSelecionada.valor) }}</div>
                    </div>
                    <div class="col-md-3">
                      <label>Categoria</label>
                      <div class="result-panel">{{ despesasSelecionada.subCategoriaDescricao }}</div>
                    </div>
                    <div class="col-md-3">
                      <label>Quantidade</label>
                      <div class="result-panel">{{ despesasSelecionada.quantidade }}</div>
                    </div>
                  </div>
                  <div class="d-flex expensesSelected">
                    <div class="col-md-12">
                      <label>Observação</label>
                      <div class="result-panel">{{ despesasSelecionada.observacao }}</div>
                    </div>
                  </div>
                  <div v-if="midiapdf != null && isMSG === false ">
                    <div>
                    <div v-if="this.isExcel && !this.isPdf" class=" download-comprovante-excel" @click="downloadComprovante()"><i class="fas fa-download"></i>
                    </div>
                      <i v-if="this.isExcel && !this.isPdf" class="arquivo-excel fas fa-file-excel mr-1 fa-5x"></i>
                      <div class="comprovante-footer" v-if="this.isExcel && !this.isPdf" @click="openDetailsimg">
                        {{ arquivodespesaid.data != null ? arquivodespesaid.data.arquivo != null ? arquivodespesaid.data.arquivo.name : "N/D" : "N/D" }}
                      </div>
                    </div>
                    <div class="img-container"  v-if="!this.isPdf && !this.isExcel && midiapdf != null">
                      <img
                      v-if="!this.isPdf && !this.isExcel"
                      style="overflow: hidden; height: 50vh;"
                      class="pdf-overview"
                      @click="openDetailsimg"
                      :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf ">
                      <div class="comprovante-footer" @click="openDetailsimg">
                        {{ arquivodespesaid.data != null ? arquivodespesaid.data.arquivo != null ? arquivodespesaid.data.arquivo.name : "N/D" : "N/D" }}
                      </div>
                    </div>
                    <div class="comprovante-container" v-if="midiapdf != null">
                      <object class="img-container" v-if="this.isPdf && !this.isExcel">
                        <div class="d-flex flex-column">
                            <iframe
                              style="overflow: hidden; height: 50vh;"
                              frameborder="0"
                              scrolling="no"
                              id="pdfViewer"
                              width="100%"
                              :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf">
                            </iframe>
                            <div class="comprovante-footer" v-if="this.isPdf && !this.isExcel" @click="openDetailsimg">
                              <i class="fas fa-search" ></i>
                              {{ arquivodespesaid.data != null ? arquivodespesaid.data.arquivo != null ? arquivodespesaid.data.arquivo.name : "N/D" : "N/D" }}
                            </div>
                        </div>
                      </object>
                    </div>
                  </div>
                  <div v-else class="d-flex icone-erro">
                    <div class="img-container"  v-if="!this.isPdf && !this.isExcel && midiapdf != null" @click="openDetailsimg">
                      <i class="fas fa-file fa-5x d-flex icone-erro"></i>
                      <div class="comprovante-footer" @click="openDetailsimg">
                        {{ arquivodespesaid.data != null ? arquivodespesaid.data.arquivo != null ? arquivodespesaid.data.arquivo.name : "N/D" : "N/D" }}
                      </div>
                    </div>
                  </div>
              </div>
                </div>
          </div>
    </b-modal>
    <b-modal ref="Detailsimg" hide-footer hide-header size="lg">
          <div class="fa fa-times closePopup" @click="closeDetailsimg"></div>
          <div class="popup-detcomprovante">
            <img
                    v-if="!this.isPdf && !this.isExcel && !this.isMSG"
                    style="overflow: hidden"
                    class="pdf-overview"
                    @click="openDetailsimg"
                    :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf ">
            <iframe
            v-if="this.isPdf && !this.isExcel"
            centered
            allowfullscreen
            id="pdfViewer"
            tyle="overflow: hidden"
            frameborder="0"
            scrolling="no"
            width="100%"
            height="100%"
            :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf">
          </iframe>
          <div class="img-container"  v-if="!this.isPdf && !this.isExcel && midiapdf != null" @click="openDetailsimg">
            <i class="fas fa-file fa-5x d-flex icone-erro"></i>
            <div class="comprovante-footer" @click="openDetailsimg">
              {{ arquivodespesaid.data != null ? arquivodespesaid.data.arquivo != null ? arquivodespesaid.data.arquivo.name : "N/D" : "N/D" }}
            </div>
          </div>
          <div class="download-comprovante" @click="downloadComprovante()"><i class="fas fa-download"></i></div>
        </div>
    </b-modal>

    <b-modal ref="modal-EscolhaReprova"
          size="md"
          centered
          id="add-brower-modal"
          title="Reprovação"
          :hide-footer="true"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
      >
           <div class="icone-reprova">
              <i class="fas fa-thumbs-down"></i>
          </div>
          <div>
              <div class="labelmodal conteiner">Escolha o tipo de reprovação!</div>
          </div>
          <div v-if="impedeDevolucao">
                <div class="label-atencao warning-devolucao">
                  <div class="mb-2 labelmodal conteiner"><i class="fa fa-exclamation-triangle ml-2 mr-2 text-warning"></i>Atenção!</div>
                  <div class="p-2">A despesa selecionada não pode ser devolvida pois pertence ao tipo de <b>{{ despesasSelecionada.subCategoriaDescricao }}</b></div>
                </div>
            </div>
          <div class="conteiner pt-3">
              <button  @click="modalDevolucao" class="button-info" :disabled='impedeDevolucao' :class='alertsStyle()' >DEVOLUÇÃO</button>
              <button  @click="modalDefinitivo" class="button-reprova">DEFINITIVA</button>
          </div>
      </b-modal>

    <b-modal ref="devolver-despesa"
            size="md"
            centered
            id="add-brower-modal"
            title="Devolução da Despesa"
            :hide-footer="true"
            :clickToClose="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header-close="true"
    >
            <div>
                <!-- <div class="conteiner"><i class="fa fa-window-close icone"></i></div> -->
                <div class="label conteiner">Informe o motivo da devolução!</div>
                <div class="caxa-texto conteiner">
                    <textarea class="form-control mt-3" rows="10" cols="175" v-model="motivo"></textarea>
                </div>
            </div>
            <div class="conteiner pt-3">
                <button @click="voltar" class="button-cancel">VOLTAR</button>
                <button @click="Reprove(definitivo == true ? true : false)" class="button-save">SALVAR</button>
            </div>
    </b-modal>
    <b-modal ref="modal-envio-coordenador"
        size="md"
        centered
        id="add-brower-modal"
        title= "Enviar para o Coordenador"
        :hide-footer="true"
        :clickToClose="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :hide-header-close="true"
    >
    <addCoordinator @onloadReacarregar="onloadReacarregar" :UnicaDespesa="UnicaDespesa"  @fecharEnviarCoordenador="fecharEnviarCoordenador" :despesasidEnviarCoordenador="despesasidEnviarCoordenador"></addCoordinator>
    </b-modal>
  </div>
</template>

<script>
import tableoccourenciadetails from './tableoccourenciadetails.js'
export default tableoccourenciadetails
</script>

<style scoped>
.icone-erro{
  justify-content: center;
  margin: 2rem;
}
::v-deep h5.modal-title {
  width: 100%;
}
.button-info{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(208 195 43);
}
.button-reprova{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(168 28 6);
}
.conteiner{
    display: flex;
    gap: 4rem;
    justify-content: center;
}
.labelmodal{
    padding: 1rem;
    font: normal normal 600 15px/20px Segoe UI;
    font-size: 20px;
    font-weight: bold;
}
.icone-reprova{
    display: flex;
    font-size: 44px;
    padding: 10px;
    justify-content: center;
}

.conteiner{
    display: flex;
    gap: 1rem;
    justify-content: center;
}
.icone{
    font-size: 50px;
    color: rgb(167, 30, 30);
}
.label{
    padding-top: 0.5rem;
    font: normal normal 600 15px/20px Segoe UI;
    font-size: 20px;
    font-weight: bold;
}

.button-cancel{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(167, 30, 30);
}
.button-save {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(4, 90, 30);
}
.button-modal {
  align-items: center;
}
.closepoup{
  cursor: pointer;
}
.check-table{
  width: 25px;
}
.btn-rep{
    width: 10vw;
    background: red;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    height: 100%;
  }
.btn-appr{
    width: 10vw;
    height: 100%;
    background: white;
    color: #008144;
    border: none;
    border-radius: 5px;
    font-weight: bold;
}
.btn-rep-popup{
    width: 10rem;
    background: red;
    color: white;
    border: none;
    font-size: 14px;
    border-radius: 5px;
    font-weight: bold;
    height: 2rem;
  }
  .btn-appr-popup{
    width: 10rem;
    height: 2rem;
    font-size: 14px;
    background: #008144;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
}
.descricao-despesa{
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  padding: 1rem;
}
.descricao{
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-around;
  flex-direction: column;
}
.detail{
  gap:1rem;
  display: flex;
  justify-content: space-around;
}
.label-details-despesas{
    font-size: 14px;
    font-weight: bold;
    line-height: 2px;
}
.btn-appr-rep {
  display: flex;
    justify-content: space-around;
    /* height: 7vh; */
    gap: 1rem;
    align-items: center;
}
.pdf-icon-container{
  width: 100%;
  height: 100%;
  display:flex;
  justify-content: center;
  align-items: center;
}
.edit-file{
    height: 25px;
    width: 40px;
    color: white;
    font-size: 12px;
    cursor: pointer;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0px;
    background: #008144;
  }
  .footer-file{
    height: 30px;
    width: 100%;
    color: rgb(163, 163, 163);
    border-radius: 0px 0px 10px 10px;
    background: #eceff1;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }

  .subtitle {
    font-size: 16px;
    font-weight: bold;
    color: #008144;
  }
  .image-comprovante{
    height: fit-content;
    width: 100% !important;
    object-fit: contain;
  }
.download-comprovante{
    height: 30px;
    top: 40px;
    display: flex;
    align-items: center;
    right: 0px;
    justify-content: center;
    color: white;
    cursor: pointer;
    width: 40px;
    background: #008144;
    border-radius: 3px 0px 0px 3px;
  }
  .comprovante-footer{
    width: 100%;
    height: fit-content;
    font-weight: bold;
    position: relative !important;
    padding: 10px;
    background: rgb(216, 216, 216);
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: gray;
    border-radius: 0px 0px 10px 10px;
    word-break: break-all;
  }
  .arquivo-excel{
    display: flex;
    justify-content: center;
    margin: 1rem;
  }
  .popup-detcomprovante{
    height: 85vh;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .download-comprovante-excel {
    height: 30px;
    position: relative;
    display: flex;
    align-items: center;
    left: 85%;
    justify-content: center;
    color: white;
    cursor: pointer;
    width: 40px;
    background: #008144;
    border-radius: 3px 0px 0px 3px;
  }
  .pdf-overview {
    width: 100%;
    height: 100%;
  }
  .result-panel {
    font-size: 14px;
    font-weight: bold;
    height: 100%;
    word-break: break-all;
  }
  .closePopup {
    display: flex;
    flex-direction: row-reverse;
  }
  .comprovante-container{
    width: 100%;
  }
  .header {
    display: flex;
    flex-wrap: wrap;
    color: white;
    justify-content: space-between;
    align-items: center;
  }
  .header-title {
    font-size: 20px;
    font-weight: bold;
  }
  .btn-header {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  .btn-repappr{
    display: flex;
    gap: 1rem;
  }

  .expensesSelected{
    width: 100%;
    align-items: flex-start;
  }
  .button-disabled {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    background-color: #dedede;
    color: #747474;
  }
  .warning-devolucao{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/tableoccourenciadetails/tableoccourenciadetails.vue